import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '../i18n.g'

Vue.use(VueI18n)

export const vuei18n = new VueI18n({ locale: 'nl', messages })

export const $t = vuei18n.t.bind(vuei18n)
